import { ApiService } from "@/api";

export const fetchCustomTpls = async (pageId: string) => {
  return ApiService.baseAction(`template/custom/${pageId}`, {});
};
